// @ts-nocheck
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Home } from './routecomponents/Home';
import ReactTooltip from 'react-tooltip';
import "../../node_modules/react-toggle-switch/dist/css/switch.min.css";
import { PopupWindow } from './sharedcomponents/PopupWindow';
import UserRights from '../actions/UserRights';
import { RCUtils } from './../RCUtils';
import { LicenseManager } from "ag-grid-enterprise";
//import OrbcommLogo from './../images/ORBCOMMLOGOR.svg';
const OrbcommLogo = require("./../images/ORBCOMMLOGOR.svg");

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058318}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Orbcomm_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{ReeferConnect}_only_for_{6}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{ReeferConnect}_need_to_be_licensed___{ReeferConnect}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_June_2025}____[v3]_[01]_MTc0OTg1NTYwMDAwMA==18c5b72d085c0d63ea61892cabbf30ac");//RCNG-1849
var Config: any = require('../Config.json');


interface MenuState {
    isSwitched: boolean;
    hasLoggedUrl: boolean;
    userLoginState: boolean;
    StickyClass: string;
    //IsDefaultDashboard: boolean;
    IsReadOnly: boolean;
    DashboardName: string;
    LayoutTypeUser: boolean;
    LayoutTypeCustomer: boolean;
    LayoutState: string;
    DashboardPreferenceId: any;
    LayoutTitle: any;
    RevisionNum: any;
}

var isCustomAttributesEnable: boolean;
var self;
export class NavMenu extends React.Component<any, MenuState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isSwitched: false,
            hasLoggedUrl: true,
            userLoginState: true,
            StickyClass: '',
            //IsDefaultDashboard: false,
            IsReadOnly: false,
            DashboardName: '',
            LayoutTypeUser: true,
            LayoutTypeCustomer: false,
            LayoutState: '',
            DashboardPreferenceId: 0,
            LayoutTitle: '',
            RevisionNum: 0
        };

        isCustomAttributesEnable = JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable;
        self = this;
    }



    toggleSwitch = () => {
        this.setState(prevState => {
            return {
                isSwitched: !prevState.isSwitched
            };
        });
    };

    logoutUser() {
        var userName = JSON.parse(sessionStorage.getItem('UserInfo')).Username;
        localStorage.setItem('login_status', 'logged_out' + '&' + userName);
        if (sessionStorage.getItem('okta-token-storage') != null || sessionStorage.getItem("azureInit") != null) {
            //this.props.history.push('/OktaLogout');
        }
        else if (sessionStorage.getItem("region") == "US") {
            //this.setState({ userLoginState: false });
           
            //sessionStorage.removeItem("UserInfo");
            //sessionStorage.removeItem("root");
            //sessionStorage.removeItem('QueryTag');
            //sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            window.location.href = "/US";
           
        }
        else if (sessionStorage.getItem("region") == "AU") {
            sessionStorage.removeItem("UserInfo");
            sessionStorage.removeItem("root");
            sessionStorage.removeItem('QueryTag');
            sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            //this.setState({ userLoginState: false });
            window.location.href = "/AU";
        } else if (sessionStorage.getItem("region") == "EU") {
            sessionStorage.removeItem("UserInfo");
            sessionStorage.removeItem("root");
            sessionStorage.removeItem('QueryTag');
            sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            //this.setState({ userLoginState: false });
            window.location.href = "/EU";
        } else if (sessionStorage.getItem("region") == "UK") {
            sessionStorage.removeItem("UserInfo");
            sessionStorage.removeItem("root");
            sessionStorage.removeItem('QueryTag');
            sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            //this.setState({ userLoginState: false });
            window.location.href = "/UK";
        } else if (sessionStorage.getItem("region") == "JP") {
            sessionStorage.removeItem("UserInfo");
            sessionStorage.removeItem("root");
            sessionStorage.removeItem('QueryTag');
            sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            //this.setState({ userLoginState: false });
            window.location.href = "/JP";
        }
        else {
            sessionStorage.removeItem("UserInfo");
            sessionStorage.removeItem("root");
            sessionStorage.removeItem('QueryTag');
            sessionStorage.removeItem('DashboardPreferenceId');
            if (localStorage.length > 0) {
                localStorage.clear();
            }
            if (sessionStorage.length > 0) {
                sessionStorage.clear();
            }
            this.setState({ userLoginState: false });
        }
    }

    componentDidMount() {
        var uri = JSON.parse(sessionStorage.getItem('UserInfo')).LogonUri;
        if (uri == null) this.setState({ hasLoggedUrl: false });

    }

    fnCancelLayout() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }
    //onDefaultCheck(event: React.FormEvent<HTMLInputElement>) {
        //var DefaultCheckBoxState: any = event.currentTarget.checked;
        //this.setState({ IsDefaultDashboard: DefaultCheckBoxState });
    //}

    onReadOnlyCheck(event: React.FormEvent<HTMLInputElement>) {
        var ReadOnlyCheckBoxState: any = event.currentTarget.checked;
        this.setState({ IsReadOnly: ReadOnlyCheckBoxState });
    }
    DashboardNamechange(event: React.FormEvent<HTMLInputElement>) {
        //var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 100)
            return false;
        //params.FenceName = Value;

        this.setState({
            DashboardName: Value
        });
    }

    LayoutTypeChange(value: any) {
        if (value == "User")
            this.setState({
                LayoutTypeUser: true,
                LayoutTypeCustomer: false,
                //IsReadOnly: false
            });
        else
            this.setState({
                LayoutTypeCustomer: true,
                LayoutTypeUser: false,
            });
    }

    static setEditLayout(layoutPreferences: any, dashboardPreferenceId: any, layoutState: any) {
        self.setState({
            LayoutTitle: 'Edit Dashboard', LayoutState: layoutState, DashboardName: layoutPreferences[0].PreferenceName, LayoutTypeCustomer: layoutPreferences[0].IsCustomerDashboard == true ? true : false,
            LayoutTypeUser: layoutPreferences[0].IsCustomerDashboard == false ? true : false,
            //IsDefaultDashboard: layoutPreferences[0].IsDefault,
            IsReadOnly: layoutPreferences[0].IsReadOnly,
            DashboardPreferenceId: dashboardPreferenceId, RevisionNum: layoutPreferences[0].RevisionNum
        }, () => $('#btnTriggerLayoutPopup').click());
    }

    static setNewLayout(layoutState: any) {
        self.setState({
            LayoutTitle: 'Create New Dashboard', LayoutState: layoutState, DashboardName: '', LayoutTypeCustomer: false, LayoutTypeUser: true,
            //IsDefaultDashboard: false, 
            IsReadOnly: false, DashboardPreferenceId: 0, RevisionNum: 0
        }, () => $('#btnTriggerLayoutPopup').click());

    }

    saveLayout() {
        if (this.state.LayoutState == "New") {
            var layoutType: any = this.state.LayoutTypeCustomer == true ? true : false;
            var layoutName: any = this.state.DashboardName;
            //var defaultLayout: any = this.state.IsDefaultDashboard;
            var readOnlyLayout: any = this.state.IsReadOnly;

            Home.SaveUserDashboardLayout(layoutType, layoutName, readOnlyLayout);
        }
        else if (this.state.LayoutState == "Edit") {
            var layoutType: any = this.state.LayoutTypeCustomer == true ? true : false;
            var layoutName: any = this.state.DashboardName;
            //var defaultLayout: any = this.state.IsDefaultDashboard;
            var readOnlyLayout: any = this.state.IsReadOnly;
            var dashboardPreferenceId: any = this.state.DashboardPreferenceId;
            var revisionNum: any = this.state.RevisionNum;

            Home.UpdateUserDashboardLayout(layoutType, layoutName, readOnlyLayout, dashboardPreferenceId, revisionNum);
        }

    }
  /*  RCNG-3190 Fix*/
    navigateDeviceFirmware()
    {
        window.location.href = '/rcdfirmwaredistribute';
    }
    navigateReeferSoftware() {
        window.location.href = '/reefersoftwaredistribute';
    }
    navigateGeofences() {
        window.location.href = '/geofencedistribute';
    }


    public render() {
        var hasReefers: boolean = false;
        var hasGensets: boolean = false;
        var hasDrys: boolean = false;
        var hasChassis: boolean = false;

        var customer = JSON.parse(sessionStorage.getItem('customerDetails'));
        if (customer != null && customer != undefined) {
            if (customer.HasReefer)
                hasReefers = true
            if (customer.HasGenset)
                hasGensets = true;
            if (customer.HasDry)
                hasDrys = true;
            if (customer.HasChassis)
                hasChassis = true;
        }
        if (!this.state.userLoginState)
            window.location.href = window.location.hostname;

        //var disableReadOnly: any = false;
        var disabledLayoutName: any = false;
        if (this.state.LayoutState == "Edit")
            disabledLayoutName = true;

        //if (this.state.LayoutTypeUser == true)
        //    disableReadOnly = true;

        return <div>
            <nav className="navbar navbar-expand-lg py-0 shadow-sm" data-bs-theme="dark">
                <div className="container-fluid">
                    <div>
                        <img src={OrbcommLogo} alt="Maritime platform" className='home-page-logo' />
                        <a className="navbar-brand poniter-events-none">MARITIME</a>
                    </div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <div className='w-5'>
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-auto">
                                <li className="nav-item">
                                    <NavLink to={'/home'} className="nav-link active">Home</NavLink>
                                    {/*<a className="nav-link active" aria-current="page" href="#">Home</a>*/}
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Assets
                                    </a>
                                    <ul className="dropdown-menu">

                                        {hasReefers == true ?
                                            <li id="reefersRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('2, 154, 155')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Reefers </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="reeferStatusRequiresRight" className={UserRights.checkVisibility('2')}>
                                                        <NavLink className="dropdown-item" to={'/reeferstatus?From=' + window.location.pathname.replace('/', '')}>
                                                            Status
                                                        </NavLink>
                                                    </li>
                                                    <li id="reeferDetailsRequiresRight" className={UserRights.checkVisibility('154')}>
                                                        <NavLink className="dropdown-item" to={'/reeferdetails?From=' + window.location.pathname.replace('/', '')}>
                                                            Details
                                                        </NavLink>
                                                    </li>
                                                    <li id="reeferCommandsRequiresRight" className={UserRights.checkVisibility('155')}>
                                                        <NavLink className="dropdown-item" to={'/reefercommandstatus?From=' + window.location.pathname.replace('/', '')} >
                                                            Command History
                                                        </NavLink>
                                                    </li>
                                                    <li id="bookingRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('100, 101')}>
                                                        <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Booking and Access </a>
                                                        <ul className='dropdown-menu dropdown-supermenu'>
                                                            <li id="generalPreferenceRequiresRight" className={UserRights.checkVisibility('100')}>
                                                                <NavLink className="dropdown-item" to={'/bookingassign'}>
                                                                    Assign and Edit
                                                                </NavLink>
                                                            </li>
                                                            <li id="cargoCareSettingsRequiresRight" className={UserRights.checkVisibility('101')}>
                                                                <NavLink className="dropdown-item" to={'/bookingunassign'}>
                                                                    Unassign
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li id="bookingRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('211, 212, 213, 214,249')}>
                                                        <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Bookings</a>
                                                        <ul className='dropdown-menu dropdown-supermenu'>
                                                            <li id="generalPreferenceRequiresRight" className={UserRights.checkVisibility('211')}>
                                                                <NavLink className="dropdown-item" to={'/Newbookingassign'} >
                                                                    Create New Booking
                                                                </NavLink>
                                                            </li>
                                                            <li id="generalPreferenceRequiresRight" className={UserRights.checkVisibility('212')}>
                                                                <NavLink className="dropdown-item" to={'/NewbookingEdit'} >
                                                                    Edit Booking
                                                                </NavLink>
                                                            </li>
                                                            <li id="viewBookingRequiresRight" className={UserRights.checkVisibility('213')}>
                                                                <NavLink className="dropdown-item" to={'/ViewBooking'} >
                                                                    View Booking
                                                                </NavLink>
                                                            </li>
                                                            <li id="unassignBookingRequiresRight" className={UserRights.checkVisibility('214')}>
                                                                <NavLink className="dropdown-item" to={'/unassignbooking'} >
                                                                    Unassign Booking
                                                                </NavLink>
                                                            </li>
                                                            <li id="generalPreferenceRequiresRight" className={UserRights.checkVisibility('249')}>
                                                                <NavLink className="dropdown-item" to={'/bookingassign'}>
                                                                    Third-Party Access
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li id="gensetAssetRequiresRight" className={UserRights.checkVisibility('202')}>
                                                        <NavLink className="dropdown-item" to={'/reefersearch'}>
                                                            Manage
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''
                                        }

                                        {hasGensets == true ?
                                            <li id="gensetsRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('151, 156, 157, 186')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Gensets </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="gensetstatusRequiresRight" className={UserRights.checkVisibility('151')}>
                                                        <NavLink className="dropdown-item" to={'/gensetstatus?From=' + window.location.pathname.replace('/', '')} activeClassName="active">
                                                            Status
                                                        </NavLink>
                                                    </li>
                                                    <li id="gensetDetailsRequiresRight" className={UserRights.checkVisibility('156')}>
                                                        <NavLink className="dropdown-item" to={'/gensetdetails?From=' + window.location.pathname.replace('/', '')} activeClassName="active">
                                                            Details
                                                        </NavLink>
                                                    </li>
                                                    <li id="gensetCommandsRequiresRight" className={UserRights.checkVisibility('157')}>
                                                        <NavLink className="dropdown-item" to={'/gensetcommandstatus?From=' + window.location.pathname.replace('/', '')} activeClassName="active">
                                                            Command History
                                                        </NavLink>
                                                    </li>
                                                    <li id="gensetAssetRequiresRight" className={UserRights.checkVisibility('186')}>
                                                        <NavLink className="dropdown-item" to={'/gensetsearch'} activeClassName="active">
                                                            Manage
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''
                                        }

                                        {hasDrys == true ?
                                            <li id="dryRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('158, 159, 160, 190')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Drys </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="drystatusRequiresRight" className={UserRights.checkVisibility('158')}>
                                                        <NavLink className="dropdown-item" to={'/drystatus?From=' + window.location.pathname.replace('/', '')}>
                                                            Status
                                                        </NavLink>
                                                    </li>
                                                    <li id="dryDetailsRequiresRight" className={UserRights.checkVisibility('159')}>
                                                        <NavLink className="dropdown-item" to={'/drydetails?From=' + window.location.pathname.replace('/', '')}>
                                                            Details
                                                        </NavLink>
                                                    </li>
                                                    <li id="dryAssetRequiresRight" className={UserRights.checkVisibility('190')}>
                                                        <NavLink className="dropdown-item" to={'/drysearch'} activeClassName="active">
                                                            Manage
                                                        </NavLink>
                                                    </li>

                                                </ul>
                                            </li> : ''
                                        }

                                        {hasChassis == true ?
                                            <li id="chassisRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('179, 180, 194')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Chassis </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="chassisstatusRequiresRight" className={UserRights.checkVisibility('179')}>
                                                        <NavLink className="dropdown-item" to={'/chassisstatus?From=' + window.location.pathname.replace('/', '')} >
                                                            Status
                                                        </NavLink>
                                                    </li>
                                                    <li id="chassisDetailsRequiresRight" className={UserRights.checkVisibility('180')}>
                                                        <NavLink className="dropdown-item" to={'/chassisdetails?From=' + window.location.pathname.replace('/', '')} >
                                                            Details
                                                        </NavLink>
                                                    </li>
                                                    <li id="chassisAssetRequiresRight" className={UserRights.checkVisibility('194')}>
                                                        <NavLink className="dropdown-item" to={'/chassissearch'}>
                                                            Manage
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''
                                        }

                                        <li id="rcdStatusRequiresRight" className={UserRights.checkVisibility('6')}>
                                            <NavLink to={'/rcdstatus?From=' + window.location.pathname.replace('/', '')} className={'dropdown-item'}>
                                                Devices
                                            </NavLink>
                                        </li>


                                        <li id="vesselStatusRequiresRight" className={UserRights.checkVisibility('38')}>
                                            <NavLink to={'/vesselstatus?From=' + window.location.pathname.replace('/', '')} className={'dropdown-item'}>
                                                Vessels
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Configuration
                                    </a>
                                    <ul className="dropdown-menu w-225">
                                        <li id="subscriptionManagerRequiresRight" className={UserRights.checkVisibility('41')}>
                                            <NavLink className="dropdown-item" to={'/subscriptionmanager'}>
                                                Subscriptions
                                            </NavLink>
                                        </li>

                                        <li id="preferencesRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('86, 87, 138, 35, 36, 146, 210')}>
                                            <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Company</a>
                                            <ul className='dropdown-menu dropdown-submenu'>
                                                <li id="generalPreferenceRequiresRight" className={UserRights.checkVisibilityMultiple('86, 87, 138')}>
                                                    <NavLink className="dropdown-item" to={'/preferencesettings'}>
                                                        General Preferences
                                                    </NavLink>
                                                </li>

                                                <li id="cargoCareProfilesRequiresRight" className={UserRights.checkVisibility('215')}>
                                                    <NavLink className="dropdown-item" to={'/cargocareprofiles'}>
                                                        CargoCare Profiles
                                                    </NavLink>
                                                </li>
                                                <li id="userSearchRequiresRight" className={UserRights.checkVisibility('35')}>
                                                    <NavLink className="dropdown-item" to={'/usersearch'}>
                                                        Users
                                                    </NavLink>
                                                </li>
                                                <li id="groupManagementRequiresRight" className={UserRights.checkVisibility('36')}>
                                                    <NavLink className="dropdown-item" to={'/groupmanagement'}>
                                                        Groups
                                                    </NavLink>
                                                </li>
                                                <li id="groupManagementRequiresRight" className={UserRights.checkVisibility('146')}>
                                                    <NavLink className="dropdown-item" to={'/geofencemanagement'}>
                                                        Geofence Management
                                                    </NavLink>
                                                </li>
                                                <li id="commandManagementRequiresRight" className={UserRights.checkVisibility('210')}>
                                                    <NavLink className="dropdown-item" to={'/commandmanagement'}>
                                                        Commands
                                                    </NavLink>
                                                </li>
                                                <li id="oemCustomerManagerRequiresRight" className={UserRights.checkVisibility('270')}>
                                                    <NavLink className="dropdown-item" to={'/oemcustomermanager'}>
                                                        OEM Customer
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li>

                                        <li id="resourceManagementRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('127, 134, 164')}>
                                            <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Resource Management</a>
                                            <ul className='dropdown-menu dropdown-submenu'>
                                                <li id="fleetManagementRequiresRight" className={UserRights.checkVisibility('127')}>
                                                    <NavLink className="dropdown-item" to={'/fleetmanagement'}>
                                                        Fleet Management
                                                    </NavLink>
                                                </li>
                                                <li id="deviceManagementRequiresRight" className={UserRights.checkVisibility('134')}>
                                                    <NavLink className="dropdown-item" to={'/devicesearch'}>
                                                        Device Management
                                                    </NavLink>
                                                </li>
                                                <li id="customAttributesRequiresRight" className={UserRights.checkVisibility('164')}>
                                                    <NavLink className="dropdown-item" to={'/customattributes'}>
                                                        Asset Attributes
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li>

                                       

                                    </ul>
                                </li>

                                <li id="deploymentRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('7, 8, 9, 10, 11, 12, 13, 43, 44, 45, 46')}>
                                    <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Deployment <span className='caret'></span></a>
                                    <ul className='dropdown-menu w-260'>
                                        <li id="newDeploymentRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('44, 45, 46')}>
                                            <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>New Deployment</a>
                                            <ul className='dropdown-menu dropdown-submenu'>
                                                <li id="reeferSoftwareRequiresRight" className={UserRights.checkVisibility('44')}>
                                                   <NavLink className="dropdown-item" to={'/reefersoftwaredistribute'}>
                                                      Reefer Software
                                                    </NavLink>
                                                    {/*<NavLink className="dropdown-item" to='' onClick={this.navigateReeferSoftware}>
                                                        Reefer Software
                                                    </NavLink>*/}
                                                </li>
                                                <li id="deviceFirmwareRequiresRight" className={UserRights.checkVisibility('45')}>
                                                    <NavLink className="dropdown-item" to={'/rcdfirmwaredistribute'}>
                                                        Device Firmware
                                                    </NavLink>
                                                    {/*<NavLink className="dropdown-item" to='' onClick={this.navigateDeviceFirmware}>
                                                        Device Firmware
                                                    </NavLink>*/}
                                                </li>
                                                <li id="geofenceDistributeRequiresRight" className={UserRights.checkVisibility('46')}>
                                                    <NavLink className="dropdown-item" to={'/geofencedistribute'} >
                                                        Geofences
                                                    </NavLink>
                                                    {/*<NavLink className="dropdown-item" to='' onClick={this.navigateGeofences} >
                                                        Geofences
                                                    </NavLink>*/}
                                                </li>
                                            </ul>
                                        </li>
                                        <li id="deploymentStatusRequiresRight" className={UserRights.checkVisibility('43')}>
                                            <NavLink className="dropdown-item" to={'/deploymentstatus'} >
                                                Deployment Status
                                            </NavLink>
                                        </li>
                                        <li id="addFileRepositoryRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('11, 12, 13')}>
                                            <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Add New File To Repository</a>
                                            <ul className='dropdown-menu dropdown-submenu'>
                                                <li id="addFileReeferSoftwareRequiresRight" className={UserRights.checkVisibility('11')}>
                                                    <NavLink className="dropdown-item" to={'/reefersoftwarefile'} >
                                                        Reefer Software File
                                                    </NavLink>
                                                </li>
                                                <li id="addFileRcdFirmwareRequiresRight" className={UserRights.checkVisibility('12')}>
                                                    <NavLink className="dropdown-item" to={'/rcdfirmwarefile'}>
                                                        Device Firmware File
                                                    </NavLink>
                                                </li>
                                                <li id="addFileGeofenceFileRequiresRight" className={UserRights.checkVisibility('13')}>
                                                    <NavLink className="dropdown-item" to={'/geofencefile'} >
                                                        Geofence File
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li>
                                        <li id="fileRepositoryManagerRequiresRight" className={UserRights.checkVisibilityMultiple('8, 9, 10')}>
                                            <NavLink className="dropdown-item" to={'/filerepository'}>
                                                File Repository Manager</NavLink>
                                        </li>
                                    </ul>
                                </li>

                                <li className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('147, 198, 266,173, 174, 175, 176, 177, 178')}>
                                    <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reports <span className='caret'></span></a>
                                    <ul className='dropdown-menu'>
                                        {hasReefers == true ?
                                            <li id="reefersReportsRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibility('147, 198, 266')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Reefers </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="reeferPowerOffRequiresRight" className={UserRights.checkVisibility('147')}>
                                                        <NavLink className="dropdown-item" to={'/poweronoff'}>
                                                            Power On/Off</NavLink>
                                                    </li>
                                                    <li id="reeferDwellTimeRequiresRight" className={UserRights.checkVisibility('198')}>
                                                        <NavLink className="dropdown-item" to={'/reeferdwelltime'}>
                                                            Dwell Time</NavLink>
                                                    </li>
                                                    <li id="reefergravityvectorRequiresRight" className={UserRights.checkVisibility('266')}>
                                                        <NavLink className="dropdown-item" to={'/gravityvector'}>
                                                            Gravity Vector</NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''}
                                        {hasGensets == true ?
                                            <li id="gensetReportsRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('173, 174, 175, 176, 177')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Gensets </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="gensetDwellTimeRequiresRight" className={UserRights.checkVisibility('173')}>
                                                        <NavLink className="dropdown-item" to={'/gensetdwelltime'}>
                                                            Dwell Time</NavLink>
                                                    </li>
                                                    <li id="gensetFuelGainRequiresRight" className={UserRights.checkVisibility('174')}>
                                                        <NavLink className="dropdown-item" to={'/gensetfuelgain'}>
                                                            Fuel Gain</NavLink>
                                                    </li>
                                                    <li id="gensetFuelLossRequiresRight" className={UserRights.checkVisibility('175')}>
                                                        <NavLink className="dropdown-item" to={'/gensetfuelloss'}>
                                                            Fuel Loss</NavLink>
                                                    </li>
                                                    <li id="gensetShorePowerRequiresRight" className={UserRights.checkVisibility('176')}>
                                                        <NavLink className="dropdown-item" to={'/gensetshorepower'}>
                                                            Shore Power</NavLink>
                                                    </li>
                                                    <li id="gensetEngineHourRequiresRight" className={UserRights.checkVisibility('177')}>
                                                        <NavLink className="dropdown-item" to={'/gensetenginehour'}>
                                                            Engine Hours</NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''}
                                        {hasDrys == true ?
                                            <li id="gensetReportsRequiresRight" className={'nav-item dropdown ' + UserRights.checkVisibilityMultiple('178')}>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Drys </a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="gensetDwellTimeRequiresRight" className={UserRights.checkVisibility('178')}>
                                                        <NavLink className="dropdown-item" to={'/drydwelltime'}>
                                                            Dwell Time</NavLink>
                                                    </li>
                                                </ul>
                                            </li> : ''}
                                    </ul>
                                </li>

                                <li id="helpRequiresRight" className='nav-item dropdown'>
                                    <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Help <span className='caret'></span></a>
                                    <ul className='dropdown-menu'>
                                        {JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd != "3P" ?
                                            <li id="newHelpRequiresRight" className='nav-item dropdown'>
                                                <a href='#' className='nav-link dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'> Documentation</a>
                                                <ul className='dropdown-menu dropdown-submenu'>
                                                    <li id="userGuideRequiresRight">
                                                        <NavLink className="dropdown-item" to={'/userguide'}>
                                                            User Guide
                                                        </NavLink>
                                                    </li>
                                                    <li id="ReleaseNotesRequiresRight">
                                                        <NavLink className="dropdown-item" to={'/releasenotes'}>
                                                            Release Notes
                                                        </NavLink>
                                                    </li>
                                                    <li id="ReleaseNotesRequiresRight">
                                                        <NavLink className="dropdown-item" to={'/oktaoinconfigguide'}>
                                                            Okta OIN Configuration Guide
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </li>
                                            : ""}
                                        <li id="feedbackRequiresRight" style={{ 'display': 'none' }}>
                                            <NavLink className="dropdown-item" to={'/feedback'} >
                                                Feedback
                                            </NavLink>
                                        </li>

                                        <li id="contactUsRequiresRight">
                                            <NavLink className="dropdown-item" to={'/contactus'}>
                                                Contact Us</NavLink>
                                        </li>
                                    </ul>
                                </li>





                            </ul>
                        </div>
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item" id='wglayoutmenu'>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link poniter-events-none" href="#" role="button" aria-expanded="false">
                                    {this.state.hasLoggedUrl ? <img src={JSON.parse(sessionStorage.getItem('UserInfo')).LogonUri} width='auto' height='30px' /> : ''}
                                </a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {sessionStorage.getItem('AZUName') != undefined && sessionStorage.getItem('AZUName') != '' ? sessionStorage.getItem('AZUName') : JSON.parse(sessionStorage.getItem('UserInfo')).Username}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end">

                                    <li id="myProfileRightRequiresRight" className={UserRights.checkVisibility('37')}>
                                        <NavLink to={'/myprofile'} className={'dropdown-item'}>
                                            My Profile
                                        </NavLink>
                                    </li>

                                    <li id="personalSettingsRequiresRight" className='d-none'>
                                        <NavLink to={'/personalsettings'} className={'dropdown-item'}>
                                            My Settings
                                        </NavLink>
                                    </li>
                                    <li>
                                        <a href={sessionStorage.getItem('region') === 'CA' ? '/CA' : sessionStorage.getItem('region') === 'US' ? '/US' : sessionStorage.getItem('region') === 'UK' ? '/UK' : sessionStorage.getItem('region') === 'AU' ? '/AU' : sessionStorage.getItem('region') === 'EU' ? '/EU' : sessionStorage.getItem('region') === 'JP' ? '/JP' : sessionStorage.getItem('okta-token-storage') != undefined ? sessionStorage.getItem("azureInit") != undefined ? '/azuresignout' : '/OktaLogout' : sessionStorage.getItem("azureInit") != undefined ? '/azuresignout' : ''} onClick={this.logoutUser} className='dropdown-item'>Sign Out</a>
                                    </li>

                                </ul>
                            </li>


                        </ul>
                        <ul className='navbar-nav' id='wgheadermenu'>
                        </ul>
                    </div>
                </div>
            </nav>

            <button id="btnTriggerLayoutPopup" data-bs-toggle="modal" className='hidden' data-bs-target="#LayoutPreferencePopUp"></button>
            <div className="modal fade" role="dialog" id="LayoutPreferencePopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title d-flex">{this.state.LayoutTitle} </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.fnCancelLayout.bind(this)}>&times;</button>
                        </div>

                        <div className="modal-body dashboard-layout-alert">
                                <div className={UserRights.checkVisibility('262') == "show" ? "row" : "row hide"}>
                                <div className="col-md-4 pe-0 text-md-end"> <span className='col-form-label'> Dashboard Type :</span> </div>
                                <div className="col-md-6">
                                    <div className="form-check form-check-inline">
                                        <input type="radio" className="form-check-input" name="GroupType" checked={this.state.LayoutTypeUser} value="User" onClick={(e) => this.LayoutTypeChange('User')} />
                                        <label className="form-check-label">User</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input type="radio" className="form-check-input" name="GroupType" checked={this.state.LayoutTypeCustomer} value="Customer" onClick={(e) => this.LayoutTypeChange('Customer')} />
                                        <label className="form-check-label">Company</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-4 pe-0 text-md-end"><label className='col-form-label mandatory-label'> Dashboard Name :</label></div>
                                <div className="col-md-4"><input type="text" maxLength={25} className='form-control' onChange={e => this.DashboardNamechange(e)} value={this.state.DashboardName} /></div>
                            </div>
                            {/*<div className="row mt-2 d-none">*/}
                            {/*    <div className="col-md-4 pe-0 text-md-end"> <span className='col-form-label'>My Default : </span> </div>*/}
                            {/*    <div className="col-md-6 col-sm-8 col-xs-8"><input type="checkbox" className='dashboard-checkbox' name="IsDefault" onChange={e => this.onDefaultCheck(e)} checked={this.state.IsDefaultDashboard} /></div>*/}
                            {/*</div>*/}
                            <div className="row mt-2">
                                <div className="col-md-4 pe-0 text-md-end"> <span className='col-form-label'>Read Only : </span> </div>
                                <div className="col-md-6 col-sm-8 col-xs-8"><input type="checkbox" className='dashboard-checkbox' name="ReadOnly" onChange={e => this.onReadOnlyCheck(e)} checked={this.state.IsReadOnly} /></div>
                            </div>

                            <div className='modal-footer mt-3'>
                                <button type='button' className='btn btn btn-secondary' onClick={this.fnCancelLayout.bind(this)}>Cancel</button>
                                <button type='button' className='btn btn-primary' onClick={this.saveLayout.bind(this)}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}
